import { getIdOrNull, requestWithPromise } from '..'
import { getDataOrDefault, HttpMethods } from '../apiHelper'

export const getSectorNote = (sector, user) => {
  return requestWithPromise(
    `/api/sectors/${getIdOrNull(sector)}/sector-notes`,
    HttpMethods.GET,
    null,
    user
  ).then(getDataOrDefault({}))
}

export const createOrUpdate = (note, sector, school, user) => {
  const body = {
    note: note,
    school: getIdOrNull(school)
  }

  return requestWithPromise(
    `/api/sectors/${getIdOrNull(sector)}/sector-notes`,
    HttpMethods.POST,
    body,
    user
  ).then(getDataOrDefault({}))
}
